import { render, staticRenderFns } from "./DeSelect.vue?vue&type=template&id=4ade3fce&"
import script from "./DeSelect.vue?vue&type=script&lang=js&"
export * from "./DeSelect.vue?vue&type=script&lang=js&"
import style0 from "./DeSelect.vue?vue&type=style&index=0&id=4ade3fce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports